module.exports = __webpack_public_path__ + "public/images/schedule/schedule-pattern-1.66cff2368f0ae12a096f48785c220c31.png";